module.exports = __webpack_public_path__ + "static/media/cotice.8a39dd8a.jpg";